import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode; label?: string };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", this.props.label, error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center p-6">
          <div className="mx-auto max-w-lg rounded-2xl border border-red-400/30 bg-red-500/10 p-6 text-sm text-red-100">
          <p className="font-semibold">{this.props.label ?? "Something went wrong"}</p>
          <p className="mt-2 font-mono text-xs break-all">{this.state.error.message}</p>
          <button
            type="button"
            className="btn-primary mt-4"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
